export default async function convertibleFromObject(obj) {
  return Object.fromEntries(
    await Promise.all(
      Object.entries(obj).map(async ([key, value]) => [key.toLowerCase(), encodeURIComponent(await value)]),
    ),
  );
}
